var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.top},[_c('v-text-field',{attrs:{"value":_vm.value,"append-icon":"search","label":"Search","single-line":"","hide-details":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }